/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import * as S from '@/widgets/tweety-widget-react-main/styles';
import './styles.css';
export interface IRadioButtonProps {
    id: string;
    fontScale?: number;

    label?: string;
    value?: string;
    errorText?: string;
    readOnly?: boolean;
    options?: { id: string; label: string }[];
    required?: boolean;
    placeholder?: string;
    direction?: 'horizontal' | 'vertical';
    labelColor?: string;
    onCompChange?(id: string, payload: any): void;
    hasError?: boolean;
}

export const RadioButton = ({
    id,
    fontScale,

    label,
    errorText,
    value,
    required,
    options,
    onCompChange,
    labelColor,
    hasError,
    direction,
    readOnly,
}: IRadioButtonProps) => {
    const [item, setItem] = useState({ textValue: value ?? '' });
    const [isInvalid, setInvalid] = useState(false);
    useEffect(() => setItem({ textValue: value ?? '' }), [value]);

    useEffect(() => {
        setInvalid(hasError);
    }, [hasError]);
    // const [textValue, setTextValue] = useState(value ?? "");
    const onChange = (id: string, e: any) => {
        setItem((prevState) => ({
            ...prevState,
            textValue: e?.target?.value,
        }));
        onCompChange && onCompChange(id, e?.target?.value);
    };
    const _renderLabelIf = () => {
        if (label) {
            return (
                <S.FormLabel fontScale={fontScale} color={labelColor}>
                    {label}
                    {required && <sup style={{ color: 'red' }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };
    // useEffect(()=>{
    //     onCompChange && onCompChange(id, value);
    // },[value])

    const _renderErrorTextIf = () => {
        if (hasError && errorText) {
            return (
                <S.FeedbackOtherLabel type="tooltip" fontScale={fontScale}>
                    {errorText}
                </S.FeedbackOtherLabel>
            );
        }
        return null;
    };
    const { textValue } = item;
    const Comp = direction === 'horizontal' ? InputGroup : React.Fragment;
    return (
        <>
            <Form.Group
                id={id}
                className=" formgroup"
                style={{ backgroundColor: readOnly ? '#F5F5F5' : '#fff' }}
            >
                {_renderLabelIf()}
                <Comp className="mx-2">
                    {options?.map((option, index) => (
                        <S.FormCheck
                            className="formcheck form-check-radio mt-1 mb-1"
                            fontScale={fontScale}
                            type={'radio'}
                            label={option?.label}
                            aria-label={`radio-${index + 1}`}
                            value={option.id}
                            onChange={onChange.bind(null, id)}
                            checked={textValue === option.id}
                            key={`radio-button-option-${option?.id}-${index}`}
                            readOnly={readOnly}
                            disabled={readOnly}
                            isInvalid={isInvalid}
                        />
                    ))}
                    {direction === 'horizontal' ? (
                        _renderErrorTextIf()
                    ) : (
                        <InputGroup>{_renderErrorTextIf()}</InputGroup>
                    )}
                </Comp>
            </Form.Group>
        </>
    );
};

RadioButton.defaultProps = {
    direction: 'horizontal',
    required: true,
    rootColor: 'grey',
    pointColor: '#000000',
    hasError: false,
    readOnly: false,
};
